<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li class="current"><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong> サービス規約 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <p class="color-red">
                        必ず内容をご確認ください。<br />
                        確認いただくことで「次へ」が押せるようになります。
                    </p>
                    <p>
                        <a href="javascript:void(0)" class="btn_trigger" v-bind:class="[termDisplayed ? 'check' : '']" @click="showTerm">サービス規約</a>
                    </p>
                    <hr class="thick" />
                </div>
                <!-- wrap_pr_2col input_area -->
                <h2 class="col5 section_title">
                    <strong> クーポンコードの入力 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <p>クーポンコードをお持ちの場合は入力してください。</p>
                    <div v-if="!promotionCode">
                        <div class="col9 col12-sp">
                            <input type="text" id="code" maxlength="20" v-model="code" />
                        </div>
                        <div class="col3 col12-sp">
                            <a class="btn_round_s white cursor-pointer" @click="promotionCodeApply">適用</a>
                        </div>
                    </div>
                    <div v-if="promotionCode">
                        <div class="col9 col12-sp">
                            <input type="text" id="code" v-model="promotionCode.displayName" readonly="readonly" class="strong" />
                        </div>
                        <div class="col3 col12-sp">
                            <a class="btn_round_s white cursor-pointer" @click="promotionCodeClear">取消</a>
                        </div>
                    </div>
                    <hr class="thick" />
                </div>
                <!-- wrap_pr_2col input_area -->
                <h2 class="col5 section_title">
                    <strong> お支払い金額 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <h3 class="strong big-16 mb-05em">初期費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>価格</span>
                            <span>&yen;0</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">-</span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span>&yen;0-(税込)</span>
                        </li>
                    </ul>
                    <h3 class="strong big-16 mb-05em">月額費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>料金</span>
                            <span>&yen;{{ formatCommafy(monthAmount) }}</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">
                                <div v-if="discountedAmount > 0">&yen;-{{ formatCommafy(discountedAmount) }}</div>
                                <div v-else>-</div>
                            </span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span
                                >&yen;{{ billingAmount() }}-(税込)
                                <div v-if="durationInMonths > 0">／ {{ durationInMonths }}ヶ月目以降 &yen;{{ formatCommafy(monthAmount) }}-(税込)</div></span
                            >
                        </li>
                    </ul>

                    <p class="submit_btn" v-bind:class="[termDisplayed ? '' : 'no-check']">
                        <input type="submit" @click="next" value="次へ" onsubmit="return false;" v-bind:disabled="!termDisplayed" />
                    </p>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                    <div v-if="planSelectable">
                        <dl class="mt-3em">
                            <dt>プラン<span class="normal small ml-05em">必須</span></dt>
                            <dd>
                                <ul>
                                    <li v-for="(plan, key) in plans" :key="key">
                                        <input type="radio" class="radio-input" v-model="selectPlan" v-bind:id="plan.value" v-bind:value="plan.value" v-on:change="changePlan()" />
                                        <label v-bind:for="plan.value">{{ plan.label }}</label>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (!from.name) {
            // メール記載のURLからの遷移の場合
            if (!document.idToken) {
                next({ name: "Top" });
                return;
            }
        } else {
            if (from.name !== "Top" && from.name !== "ContractConfirm") {
                next({ name: "Top" });
                return;
            }
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        const paramsCopy = JSON.parse(JSON.stringify(this.params));
        for (const entry of Object.entries(paramsCopy)) {
            to.params[entry[0]] = entry[1];
        }

        to.params.customerEmail = this.customerEmail;
        to.params.customerName = this.customerName;
        to.params.customerKana = this.customerKana;
        to.params.customerPostalCode = this.customerPostalCode;
        to.params.customerPrefecture = this.customerPrefecture;
        to.params.customerCity = this.customerCity;
        to.params.customerAddress = this.customerAddress;
        to.params.customerTel = this.customerTel;
        to.params.copiedStripePostalCode = this.copiedStripePostalCode;
        to.params.cards = this.cards;
        to.params.product = this.product;
        to.params.planId = this.planId;

        to.params.termDisplayed = this.termDisplayed;

        // サービス料金情報
        to.params.code = this.code;
        to.params.promotionCode = this.promotionCode;
        to.params.monthAmount = this.monthAmount;
        to.params.durationInMonths = this.durationInMonths;
        to.params.isRequiredCredit = this.isRequiredCredit;

        next();
    },
    methods: {
        formatCommafy: function (val) {
            return this.$utils.commafy(val);
        },
        billingAmount: function () {
            return this.formatCommafy(this.monthAmount - this.discountedAmount);
        },
        showTerm: function () {
            this.$emit("openTermsModal", "terms_bocco.html");
            this.termDisplayed = true;
        },
        promotionCodeApply: function () {
            // クーポンコードが指定されていない場合
            if (!this.code) {
                const errorMessage = this.$errorMessages["BoccoRentalPromotionCodeUnspecifiedException"];
                this.$emit("openAlertModal", errorMessage);
                return;
            }
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/agree/promotionCode",
                {
                    code: this.code,
                    productId: document.productId
                },
                (res) => {
                    // eslint-disable-line
                    this.$emit("hideSpinner");
                    if (res.data && res.data.promotionCode) {
                        this.promotionCode = res.data.promotionCode;
                        this.discountedAmount = res.data.discountedAmount;
                        this.isRequiredCredit = res.data.isRequiredCredit;
                        this.durationInMonths = this.promotionCode.durationInMonths;
                        // ○ヶ月目以降xx円という表示なので、+1して表示する
                        if (this.durationInMonths > 0) {
                            this.durationInMonths = this.durationInMonths + 1;
                        }
                    }
                }
            );
        },
        promotionCodeClear: function () {
            this.code = "";
            this.promotionCode = null;
            this.durationInMonths = 0;
            this.discountedAmount = 0;
            this.isRequiredCredit = true;
        },
        cancel: function () {
            // TOP画面へ遷移
            this.$router.push({
                name: "Top",
                params: {}
            });
        },
        next: function () {
            // クーポンコードチェック(必須項目ではないため、入力されていて未適用の場合)
            if (this.code && !this.promotionCode) {
                this.$emit("openAlertModal", "クーポンコードが適用されていません。");
                return;
            }
            // 顧客情報設定
            this.$emit("showSpinner", "処理中です。");
            this.$axios("POST", "/agree/next", {}, (res) => {
                this.$emit("hideSpinner");

                if (!this.customerPostalCode && res.data.customer.postalCode) {
                    // Stripe情報を取り出した時だけ郵便番号検索が不要になるようにフラグを設定(クーポンから情報入力画面に遷移するときのみ)
                    this.copiedStripePostalCode = true;
                }

                // 会員情報 ※「戻る」で戻ってきたときに元の内容を反映させるため、持っている情報を優先する
                this.customerEmail = res.data.customer.email || res.data.email || this.customerEmail;
                this.customerName = this.customerName || res.data.customer.name;
                this.customerKana = this.customerKana || res.data.customer.kana;
                this.customerPostalCode = this.customerPostalCode || res.data.customer.postalCode;
                this.customerPrefecture = this.customerPrefecture || res.data.customer.prefecture;
                this.customerCity = this.customerCity || res.data.customer.city;
                this.customerAddress = this.customerAddress || res.data.customer.address;
                this.customerTel = this.customerTel || res.data.customer.tel;
                this.cards = this.cards || res.data.customer.cards;
                // 入力画面へ遷移
                this.$router.push({
                    name: "ContractForm",
                    params: {}
                });
            });
        },
        filterPlan: function () {
            const plan = this.product.plans.find((p) => p.id === this.planId);
            this.monthAmount = plan.amount;
            this.displayRenewal = plan.displayRenewal;
            if (!this.cancelAmount) {
                const planCancel = this.product.plans.find((p) => p.id === "cancel");
                this.cancelAmount = planCancel.amount;
            }
        },
        changePlan: function () {
            this.planId = this.selectPlan;
            this.filterPlan();
            // 割引額の計算(小数第一位を四捨五入)は、API（/agree/promotionCode）で行うようにするため、計算処理のみpromotionCodeApplyからここに移動
            // 現状複数プランが存在せずこのメソッドは実質的には使用されていないが処理は残しておく
            if (this.promotionCode && this.promotionCode.percentOff) {
                this.discountedAmount = Math.round((this.monthAmount * this.promotionCode.percentOff) / 100);
            } else if (this.promotionCode && this.promotionCode.amountOff) {
                this.discountedAmount = this.promotionCode.amountOff;
            }
        }
    },
    data: function () {
        return {
            planId: "", // いずれ選択可能とする可能性があるため
            paramData: {},
            product: {},
            code: "",
            promotionCode: null,
            monthAmount: 0,
            cancelAmount: 0,
            durationInMonths: 0,
            termDisplayed: false,
            rentalProduct: "",
            displayRenewal: "",
            discountedAmount: 0,
            isRequiredCredit: true, // クレジットカードが必須かどうかのフラグ
            // ↓ 開発用 ↓
            planSelectable: process.env.VUE_APP_CAN_PLAN_SELECT,
            selectPlan: "month",
            selectPlanLabel: "",
            plans: [
                { value: "month", label: "月額" },
                { value: "day", label: "日額" }
            ]
        };
    },
    created() {
        this.params = this.$route.params;
        this.isRequiredCredit = this.params.isRequiredCredit || true;

        this.planId = this.$route.params.planId || "month";
        // 商品情報を持っていない場合 (初回読み込み時)
        if (!this.$route.params || !this.$route.params.product) {
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/agree/product",
                {
                    productId: document.productId
                },
                (res) => {
                    // eslint-disable-line
                    this.$emit("hideSpinner");
                    if (res.data && res.data.product) {
                        this.paramData.product = res.data.product;
                        this.product = this.paramData.product;
                        this.filterPlan();
                    }
                }
            );
        }
        // 商品情報を持っている場合 (「入力内容を修正」ボタンや、ブラウザで戻られた場合)
        else {
            // サービス料金
            this.paramData = this.$route.params;
            this.product = this.$route.params.product;
            this.code = this.$route.params.code;
            this.promotionCode = this.$route.params.promotionCode;
            this.monthAmount = this.$route.params.monthAmount;
            this.durationInMonths = this.$route.params.durationInMonths;

            //  会員情報
            this.customerEmail = this.$route.params.customerEmail;
            this.customerName = this.$route.params.customerName;
            this.customerKana = this.$route.params.customerKana;
            this.customerPostalCode = this.$route.params.customerPostalCode;
            this.customerPrefecture = this.$route.params.customerPrefecture;
            this.customerCity = this.$route.params.customerCity;
            this.customerAddress = this.$route.params.customerAddress;
            this.customerTel = this.$route.params.customerTel;
            this.cards = this.$route.params.cards;

            this.termDisplayed = true;

            // productから表示用項目を取得(※戻りの場合も必要なため)
            this.filterPlan();
        }
    }
};
</script>

<style scoped>
.default_list.local li > span:first-child {
    font-weight: normal;
}
</style>
